import React from "react";
import { Collapse } from "@arco-design/web-react";

// MUI Accordion -> Arco Collapse. `accordion` keeps the old single-panel-open
// behavior. Each item may carry a stable `key` (used as the panel name so the
// open panel survives reordering and can be deep-linked); otherwise the index is
// used. `defaultActiveKey` picks which panel starts open (defaults to the first).
// Pass `activeKey` + `onChange` instead to control it (e.g. to open a section
// from elsewhere on the page). Each header carries id="section-<key>" so a
// caller can scroll to it.
export default function AccordionEditors({ items, defaultActiveKey, activeKey, onChange }) {
  const nameFor = (item, index) => (item.key != null ? String(item.key) : String(index));
  const initial =
    defaultActiveKey != null ? [String(defaultActiveKey)] : [nameFor(items[0] || {}, 0)];
  const controlled = activeKey !== undefined
    ? { activeKey: activeKey ? [String(activeKey)] : [], onChange: (key, keys) => onChange && onChange(keys && keys.length ? keys[keys.length - 1] : "") }
    : { defaultActiveKey: initial };

  return (
    <Collapse accordion {...controlled} style={{ width: "100%" }}>
      {items.map((item, index) => (
        <Collapse.Item
          key={nameFor(item, index)}
          name={nameFor(item, index)}
          header={<span id={`section-${nameFor(item, index)}`}>{item.title}</span>}
          disabled={item.disabled}
        >
          {item.component}
        </Collapse.Item>
      ))}
    </Collapse>
  );
}
